module.exports = __webpack_public_path__ + "static/media/il-2sturmovik.de94cca9.jpg";